import { Icon } from '@iconify/react';

// Loading and empty states, shared by the table and the card grid so both
// render the same thing at the same size.

export const VisitorLoader = ({ label = 'Loading visitors...' }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-12">
        <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-gray-200 tw-border-t-sky-500"></div>
        <span className="tw-text-xs tw-text-gray-400">{label}</span>
    </div>
);

// Two different empties: "nothing matches your filters" is a dead end the user
// created and can undo, while "nothing here yet" is an invitation to start.
export const VisitorEmptyState = ({ filtered, canCreate, onClear, onCreate }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-14 tw-px-4 tw-text-center">
        <div className="tw-w-12 tw-h-12 tw-rounded-full tw-bg-gray-100 tw-text-gray-400 tw-flex tw-items-center tw-justify-center">
            <Icon icon="mdi:account-search-outline" className="tw-text-2xl" />
        </div>
        <p className="tw-mb-0 tw-text-xs tw-font-semibold tw-text-gray-600">
            {filtered ? 'No visitors match these filters' : 'No visitors registered yet'}
        </p>
        <p className="tw-mb-0 tw-text-[11px] tw-text-gray-400 tw-max-w-xs">
            {filtered
                ? 'Try a different name, number or type.'
                : 'Register a visitor once — every future visit, pre-approval and gate pass links back to that record.'}
        </p>
        {filtered ? (
            <button
                onClick={onClear}
                className="tw-mt-1 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded-md hover:tw-bg-gray-50"
            >
                Clear filters
            </button>
        ) : canCreate && (
            <button
                onClick={onCreate}
                className="tw-mt-1 tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-sky-600 hover:tw-bg-sky-700"
            >
                <Icon icon="mdi:plus" className="tw-text-base" />
                Register Visitor
            </button>
        )}
    </div>
);
